import React from "react";

const useWebNotifications = isMobile => {
  React.useEffect(() => {
    // need service worker for mobile
    if (isMobile || !("Notification" in window)) {
      return;
    }

    if (Notification.permission === "granted") {
      return;
    }
    if (Notification.permission !== "denied" || Notification.permission === "default") {
      try {
        Notification.requestPermission();
      } catch (error) {}
    }
  }, [isMobile]);
};

export default useWebNotifications;
